import { render, staticRenderFns } from "./PasesInternosAsignar.vue?vue&type=template&id=88dc3e72&scoped=true&"
import script from "./PasesInternosAsignar.vue?vue&type=script&lang=js&"
export * from "./PasesInternosAsignar.vue?vue&type=script&lang=js&"
import style0 from "./PasesInternosAsignar.vue?vue&type=style&index=0&id=88dc3e72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dc3e72",
  null
  
)

export default component.exports